export default __webpack_public_path__ + "static/media/nicolas.41b2be29.jpeg";